import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import type { IBookPreview } from '@shared/jp/data/products';
import type { TBookAlias } from '@shared/jp/product';

@Component({
  selector: 'app-books[books]',
  templateUrl: './books.component.html',
  styleUrls: ['./books.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BooksComponent {
  @Input() books!: IBookPreview[];

  @Output() buttonClick = new EventEmitter<TBookAlias>();

  public onButtonClick(alias: TBookAlias) {
    this.buttonClick.emit(alias);
  }
}
